import { render, staticRenderFns } from "./DataCollectionSection.vue?vue&type=template&id=cea0a1ee&scoped=true&"
import script from "./DataCollectionSection.vue?vue&type=script&lang=js&"
export * from "./DataCollectionSection.vue?vue&type=script&lang=js&"
import style0 from "./DataCollectionSection.vue?vue&type=style&index=0&id=cea0a1ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea0a1ee",
  null
  
)

export default component.exports